
import React, { useState, useEffect }  from "react";
import { connect } from "react-redux";
import moment from 'moment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import MenuItem from '@material-ui/core/MenuItem';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  updateitem,
} from '../api/item.api';
import { getAlltransmision } from '../api/transmision.api';
import { getAllcountry } from '../api/country.api';
import { getAllVeterinaryClinic } from '../api/VeterinaryClinic.api';
import { getAllstate } from '../api/state.api';

import { getUsers } from '../api/user.api';

const LoftyitemUpdateModal = ({open, handleClose, successAction, token, doc}) => {
  const [dataLoftytransmision, setDataLoftytransmision] = useState([]);
const [dataLoftycountry, setDataLoftycountry] = useState([]);
const [dataLoftyVeterinaryClinic, setDataLoftyVeterinaryClinic] = useState([]);
const [dataLoftystate, setDataLoftystate] = useState([]);

  const [dataUser, setDataUser] = useState([]);

  useEffect(() => {
    const handleDataLoftyApps = async () => {
      try {
				const resLoftytransmision = await getAlltransmision({ token });
				setDataLoftytransmision(resLoftytransmision.data);
				const resLoftycountry = await getAllcountry({ token });
				setDataLoftycountry(resLoftycountry.data);
				const resLoftyVeterinaryClinic = await getAllVeterinaryClinic({ token });
				setDataLoftyVeterinaryClinic(resLoftyVeterinaryClinic.data);
				const resLoftystate = await getAllstate({ token });
				setDataLoftystate(resLoftystate.data);

				const resUser = await getUsers({ token });
				setDataUser(resUser.data);

      } catch (error) {
        // error
      }
    }
    handleDataLoftyApps();
  }, []);
  return (
    <Dialog fullWidth open={open} onClose={handleClose}>
      <DialogTitle>
        Actualizar item
      </DialogTitle>
      <DialogContent>
        <form
          onSubmit={async e => {
            e.preventDefault();
            try {
              await updateitem({
                token: token,
                _id: doc._id,
                description: e.target.description.value,
							type: e.target.type.value,
							idTransmision: e.target.idTransmision.value,
							idCountry: e.target.idCountry.value,
							city: e.target.city.value,
							idUser: e.target.idUser.value,
							gender: e.target.gender.value,
							lost: e.target.lost.checked,
							color: e.target.color.value,
							numberMicroship: e.target.numberMicroship.value,
							colorcast: e.target.colorcast.value,
							species: e.target.species.value,
							idVeterinaryClinic: e.target.idVeterinaryClinic.value,
							extraInformation: e.target.extraInformation.value,
							medicines: e.target.medicines.value,
							allergies: e.target.allergies.value,
							phone1: e.target.phone1.value,
							phone2: e.target.phone2.value,
							idState: e.target.idState.value,
							vaccines: e.target.vaccines.value,
							surgeries: e.target.surgeries.value,
							childbirth: e.target.childbirth.value,
							pedigree: e.target.pedigree.value,
							dewormers: e.target.dewormers.value,
							fractures: e.target.fractures.value,
							scars: e.target.scars.value,
							reward: e.target.reward.value,
							brand: e.target.brand.value,
							imei: e.target.imei.value,
							age: new Date(e.target.age.value),
							validItem: e.target.validItem.checked,
							numberPlate: e.target.numberPlate.value,
							haveReward: e.target.haveReward.checked,
							textModel: e.target.textModel.value,
							idPdf: e.target.idPdf.value,

              });
              if (successAction) {
                successAction();
              }
              alert('Se agrego exitosamente el dato');
            } catch (error) {
              if (error.info) {
                alert(error.info);
              } else {
                alert('Lo sentimos no se logro agregar el dato');
              }
            }
          }}
        >
  				<div className="my-3">
					<TextField type="text" name="description" label="Descripcion" variant="outlined" defaultValue={doc?.description} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="type" label="Tipo" variant="outlined" defaultValue={doc?.type} fullWidth />
				</div>
				<div className="my-3">
					<TextField name="idTransmision" label="idTransmision" defaultValue={doc?.idTransmision} variant="outlined" fullWidth select>
						{
							dataLoftytransmision.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.nameSpanish}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField name="idCountry" label="idCountry" defaultValue={doc?.idCountry} variant="outlined" fullWidth select>
						{
							dataLoftycountry.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.name}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField type="text" name="city" label="Ciudad" variant="outlined" defaultValue={doc?.city} fullWidth />
				</div>
				<div className="my-3">
					<TextField defaultValue={doc?.idUser} name="idUser" label="idUser" variant="outlined" fullWidth select>
						{
							dataUser.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.loftyEmail}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField type="text" name="gender" label="Genero" variant="outlined" defaultValue={doc?.gender} fullWidth />
				</div>
				<div className="my-3">
					<FormControl className="my-4">
						<FormControlLabel
							control={(
								<Checkbox
									name="lost"
									color="primary"
									defaultChecked={doc?.lost}
								/>
							)}
							label="Perdido"
						/>
					</FormControl>
				</div>
				<div className="my-3">
					<TextField type="text" name="color" label="Color" variant="outlined" defaultValue={doc?.color} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="numberMicroship" label="Numero de microship" variant="outlined" defaultValue={doc?.numberMicroship} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="colorcast" label="Raza" variant="outlined" defaultValue={doc?.colorcast} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="species" label="Especie" variant="outlined" defaultValue={doc?.species} fullWidth />
				</div>
				<div className="my-3">
					<TextField name="idVeterinaryClinic" label="idVeterinaryClinic" defaultValue={doc?.idVeterinaryClinic} variant="outlined" fullWidth select>
						{
							dataLoftyVeterinaryClinic.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.name}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField type="text" name="extraInformation" label="Información extra" variant="outlined" defaultValue={doc?.extraInformation} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="medicines" label="Medicamentos" variant="outlined" defaultValue={doc?.medicines} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="allergies" label="Alergias" variant="outlined" defaultValue={doc?.allergies} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="phone1" label="Telefono1" variant="outlined" defaultValue={doc?.phone1} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="phone2" label="Telefono 2" variant="outlined" defaultValue={doc?.phone2} fullWidth />
				</div>
				<div className="my-3">
					<TextField name="idState" label="idState" defaultValue={doc?.idState} variant="outlined" fullWidth select>
						{
							dataLoftystate.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.name}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField type="text" name="vaccines" label="Vacunas" variant="outlined" defaultValue={doc?.vaccines} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="surgeries" label="Cirugías" variant="outlined" defaultValue={doc?.surgeries} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="number" name="childbirth" label="Número de partos" variant="outlined" defaultValue={doc?.childbirth} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="pedigree" label="Pedigree" variant="outlined" defaultValue={doc?.pedigree} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="dewormers" label="Desparasitantes" variant="outlined" defaultValue={doc?.dewormers} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="fractures" label="Fracturas" variant="outlined" defaultValue={doc?.fractures} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="scars" label="Cicatrices" variant="outlined" defaultValue={doc?.scars} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="number" name="reward" label="Recompensa" variant="outlined" defaultValue={doc?.reward} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="brand" label="Marca" variant="outlined" defaultValue={doc?.brand} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="imei" label="IMEI #" variant="outlined" defaultValue={doc?.imei} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="date" name="age" label="Fecha de nacimiento" variant="outlined" defaultValue={doc?.age ? moment(doc?.age).format('YYYY-MM-DD') : ''} fullWidth />
				</div>
				<div className="my-3">
					<FormControl className="my-4">
						<FormControlLabel
							control={(
								<Checkbox
									name="validItem"
									color="primary"
									defaultChecked={doc?.validItem}
								/>
							)}
							label="Valido"
						/>
					</FormControl>
				</div>
				<div className="my-3">
					<TextField type="text" name="numberPlate" label="Numero de Placa" variant="outlined" defaultValue={doc?.numberPlate} fullWidth />
				</div>
				<div className="my-3">
					<FormControl className="my-4">
						<FormControlLabel
							control={(
								<Checkbox
									name="haveReward"
									color="primary"
									defaultChecked={doc?.haveReward}
								/>
							)}
							label="Posee Recompensa"
						/>
					</FormControl>
				</div>
				<div className="my-3">
					<TextField type="text" name="textModel" label="Modelo" variant="outlined" defaultValue={doc?.textModel} fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="idPdf" label="Archivo PDF" variant="outlined" defaultValue={doc?.idPdf} fullWidth />
				</div>

          <div className="my-3 text-center">
            <Button type="submit" variant="outlined" color="primary">
              Actualizar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = state => state.auth;

export default connect(mapStateToProps)(LoftyitemUpdateModal);
